import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { PreviewDataImportRequest } from 'src/app/messaging/previewImportDataRequest';
import { ConfigService } from 'src/app/services/config/config.service';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { TransformerViewModel } from '../../../transformer-list/transformer-list.component';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { TransformDetailViewModelBase } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/transformDetailViewModelBase';
import { SortInfo } from '../../../../domainObjects/sortInfo';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { ValidationInfo, RequiredFieldValidation } from 'src/app/objectModel/validationInfo';
import { TransformerParametersViewModel } from '../transformer-parameters/transformerParametersViewModel';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { JoinerMapper, JoinerTransform, JoinerTransformConfig, MergeOption } from 'src/app/domainObjects/transformers/joinerTransform';
import { JoinerRuleViewModel } from './joinerRuleViewModel';
import { JoinerPreviewDataResponse } from 'src/app/messaging/joinerPreviewDataResponse';
import { JoinerMapperViewModel } from './JoinerMapperViewModel';
import { GetDataFarmPreviewResponse } from 'src/app/messaging/getDataFarmPreviewResponse';
import { DuplicateKeep, DuplicateType } from '../column-cleaner-transform-detail/columnCleanerRuleViewModel';
import { ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { JoinerMergedOptionViewModel } from './JoinerMergedOptionViewModel';
import { CacheKeyType, TransformType } from 'src/app/domainObjects/transformType';

export class JoinerViewModel extends TransformDetailViewModelBase<JoinerTransform> {
    farmType: DataFarmType;

    sampleStart: number;
    sampleEnd: number;
    reserialzeJids: boolean;
    //mergeOption:MergeOption[]=[];
    mergeOption: Array<JoinerMergedOptionViewModel> = [];
    //rules: Array<JoinerRuleViewModel> = [];
    fieldMap: Array<JoinerMapperViewModel> = [];
    parameters:TransformerParametersViewModel=null;
    rows: number;
    commonFields:Array<string>;
    resetRows: boolean; 
    runDedup: boolean;
    fieldList?: ColoredTextItem[]=[];
    duplicatesType: DuplicateType;
    duplicatesKeep: DuplicateKeep;
    // Status
    // hitCount?: number;
    // missCount?: number;
    // hitRatio?: number;
    // rowsDisplay?: string;
    // hitRatioDisplay?: string;
  
    request: PreviewDataImportRequest;
    response: JoinerPreviewDataResponse;

    constructor(
      dataDictService: DataDictionaryService,
      private configService: ConfigService,
      configViewModel: DataTransformConfigViewModel,
      transformViewModel: TransformerViewModel) {

        super(dataDictService, configViewModel, transformViewModel);

        const transformConfig = this.transform.transformConfig;
        this.parameters=new TransformerParametersViewModel();
        if (transformConfig) {
          this.farmType = transformConfig.farmType ?? transformViewModel.transform.dataFarmType;
          this.sortInfo = transformConfig.sortInfo;
          this.sampleEnd = transformConfig.sampleEnd + 1;
          this.sampleStart = transformConfig.sampleStart + 1;
          this.reserialzeJids = transformConfig.reserialzeJids;
          this.resetRows = transformConfig.resetRows;
          this.runDedup = transformConfig.runDedup;
         // this.mergeOption = transformConfig.mergeOption || [];
           if (transformConfig.mergeOption) {
            this.mergeOption = transformConfig.mergeOption.map(r => new JoinerMergedOptionViewModel(r));
          }

          this.duplicatesType = transformConfig.duplicatesType;
          this.duplicatesKeep = transformConfig.duplicatesKeep;
          let colorIndex = 0;
          const maxIndex = NamedColorList.length - 1;
          this.fieldList = transformConfig.fieldList?.map(r => {
            if (colorIndex > maxIndex) {
              colorIndex = 0;
            }
            return new ColoredTextItem(r, NamedColorList[colorIndex++]);
          });
          // if (transformConfig.rules) {
          //   this.rules = transformConfig.rules.map(r => new JoinerRuleViewModel(r));
          // }
          if (transformConfig.fieldMap) {
            this.fieldMap = transformConfig.fieldMap.map(r => new JoinerMapperViewModel(r));
          }

          this.parameters.sortInfo= transformConfig.sortInfo;
          this.parameters.sampleStart = transformConfig.sampleStart + 1;
          this.parameters.sampleEnd = transformConfig.sampleEnd + 1;
        }
    }

    override configureValidationInfo(): ValidationInfo[] {
      const infos = [];
      //infos.push( new RequiredFieldValidation('threads', 'Threads (0 > Auto)'));
      return infos;
    }

    public override onTransformRunCompleted(response: JoinerPreviewDataResponse): void {
      
    }

    override toTransformConfig(): JoinerTransformConfig {
      const config = new JoinerTransformConfig();
      config.farmType = this.farmType;
      config.transformType = TransformType.farmJoiner;
      if(this.parameters.sortInfo){
        if(this.parameters.sortInfo.length==0){
          config.sortInfo =undefined;
        }else{
          config.sortInfo=this.parameters.sortInfo;
        }
      }
      config.sampleStart =this.parameters.sampleStart-1;
      config.sampleEnd =this.parameters.sampleEnd-1;
      config.reserialzeJids = this.reserialzeJids;
      config.resetRows = this.resetRows;
      config.runDedup = this.runDedup;

      config.mergeOption = this.mergeOption.map(r => {
        const mOption= r.toJoinerMergeOption();

        return mOption;
      });
      config.duplicatesType = this.duplicatesType;
      config.duplicatesKeep = this.duplicatesKeep;
      config.fieldList = this.fieldList?.map(a => a.text);
      
      config.fieldMap = this.fieldMap.map(r => {
        const mapper= r.toJoinerMapper();

        return mapper;
      });

      return config;
    }
  }

  export class JoinerSummaryViewModel{
    nodeID:string;
    node: string;
    name: string;
    fields: string;
    mapped: string;
    rows: string;
    nodeColor:string;
    state:boolean;
    field:string;
  }
  export class JoinerListRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    cacheKeyType:CacheKeyType;
  }
  export class JoinerListResponse {
    nodeID:string;
    index: number;
    indexName:string;
    nodeColor:string;
    nodeFields:string;
    nodeName:string;
    nodeNo:string;
    nodeRows:string;
    mapTable:JoinerMapper[];
    nodePreviewData:GetDataFarmPreviewResponse;
  }
  
